import { render, staticRenderFns } from "./CrearDescargaActividadModal.vue?vue&type=template&id=ddb77634&"
import script from "./CrearDescargaActividadModal.vue?vue&type=script&lang=ts&"
export * from "./CrearDescargaActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ddb77634', component.options)
    } else {
      api.reload('ddb77634', component.options)
    }
    module.hot.accept("./CrearDescargaActividadModal.vue?vue&type=template&id=ddb77634&", function () {
      api.rerender('ddb77634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/crud/crear/CrearDescargaActividadModal.vue"
export default component.exports